import React from 'react';

const IconMicrosoft = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4158_167)">
        <path d="M0.869629 0.869568H9.56528V9.56522H0.869629V0.869568Z" fill="#F35325" />
        <path d="M10.4348 0.869568H19.1305V9.56522H10.4348V0.869568Z" fill="#81BC06" />
        <path d="M0.869629 10.4348H9.56528V19.1304H0.869629V10.4348Z" fill="#05A6F0" />
        <path d="M10.4348 10.4348H19.1305V19.1304H10.4348V10.4348Z" fill="#FFBA08" />
      </g>
      <defs>
        <clipPath id="clip0_4158_167">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconMicrosoft;
